export const selectTitle = {
    "albums": "an album",
    "artists": "an artist",
    "playlists": "a playlist",
    "tracks": "a track",
    "banners": "a banner",
    "moods": "a mood",
}